import { ApiState, Action } from '../../../types';
import { User } from '../../../services/types/User';
import { serviceReducer, callService } from '../../../shared/hooks/serviceReducer';

export interface UserQuery {
  query: string;
  convergence: boolean;
  includeGS: boolean;
}

export type SearchUserAction =
  | Action<User[], UserQuery>
  | {
      type: 'QUERY_USER';
      query: string;
      convergence: boolean;
    }
  | {
      type: 'SET_INITIAL_USERS';
      initialUsers: User[];
    };

const reducer = (
  state: ApiState<User[], UserQuery>,
  action: SearchUserAction
): ApiState<User[], UserQuery> => {
  switch (action.type) {
    case 'QUERY_USER': {
      const filter = { query: action.query, convergence: action.convergence };
      return callService(state, filter);
    }
    case 'SET_INITIAL_USERS': {
      const { initialUsers } = action;
      return { ...state, data: initialUsers };
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
